<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_i">T<span class="small">OO</span> G<span class="small">REAT A</span> B<span class="small">URDEN TO</span> B<span class="small">EAR</span></a></p><a id="page_i">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?3759cd10